import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import Helmet from 'react-helmet'
import styled from 'styled-components'

const PostLink = styled(Link)`
  display: block;
  padding: 1.5rem 1rem;
  color: inherit;
  text-decoration: none;
  text-align: center;
  transition: all .1s ease;
  box-shadow: inset 0 -1px 0 rgba(0,0,0,.125);

  h2 {
    margin: 0;
  }

  h4 {
    margin: 0;
    font-weight: 400;
  }

  :hover {
    background-color: #ececec;
  }
`

const Timeline = ({ pages, language }) => {
  return (
    <div>
      {pages.filter(
        page => page.node.featuredContent === null && page.node.node_locale === language
      ).map(({ node: page }) => {
        return (
          <PostLink to={page.slug} key={page.id}>
            <h2>{page.title}</h2>
            <h4>{page.subtitle}</h4>
          </PostLink>
        );
      })}
    </div>
  )
}

export default Timeline



// WEBPACK FOOTER //
// ./src/components/timeline.js